import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Popover } from 'antd';
import localStorageUtil from '$/common/utils/localStorageUtil';
import IconFont from '$/components/IconFont';
import { useLanguageStore, LanguageCodeType, getLanguageSelectConfig } from '$/store/languageStore';
import classNames from 'classnames';
import styles from './index.module.scss';

export default function LanguageSwitch() {
  const languageStore = useLanguageStore((state) => state.languageStore);
  const [languageCode, setLanguageCode] = useState<LanguageCodeType | ''>('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setLanguageCode(
      (localStorageUtil.getItem('lang') as LanguageCodeType) || '',
    );
  }, []);

  const options = getLanguageSelectConfig();
  const currentLabel = options.find((o) => o.value === languageCode)?.label
    || languageStore.smartcatTranslationText(
      (v) => v.RoboNeo_Web_toast_setting_follow_system,
    );

  const handleChange = (value: LanguageCodeType | '') => {
    setLanguageCode(value);
    localStorageUtil.setItem('lang', value);
    Cookies.set('lang', value);
    window.mtstat?.track('system_settings_click', {
      language: value === '' ? 'system' : value,
    });
    setOpen(false);
    setTimeout(() => {
      window.location.reload();
    });
  };

  const content = (
    <div className={styles.dropdownContent}>
      {options.map((option) => (
        <div
          key={option.value}
          className={classNames(styles.optionItem, {
            [styles.active]: option.value === languageCode,
          })}
          onClick={() => handleChange(option.value)}
        >
          <span className={styles.checkIcon}>
            {option.value === languageCode && (
              <IconFont name="checkBoxMark" fontSize={14} />
            )}
          </span>
          <span>{option.label}</span>
        </div>
      ))}
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
      trigger={['click']}
      overlayClassName="resetPopoverAndArrow"
      content={content}
    >
      <div className={styles.languageSwitch}>
        <IconFont name="earthBold" fontSize={16} />
        <span className={styles.label}>{currentLabel}</span>
      </div>
    </Popover>
  );
}
